var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99942 4.41986L11 3.29464V4.21007L7.99942 5.33529V4.41986ZM7.14228 4.36585L3.5 3V13.6654L7.14228 15.0313V14.1159L4.35714 13.0714V4.23686L7.14228 5.28128V4.36585ZM7.99942 14.1699V15.0853L11 13.9601V13.0446L7.99942 14.1699ZM14.6429 14.1429L11.8571 13.0982V14.0136L15.5 15.3797V4.71429L11.8571 3.34821V4.26364L14.6429 5.30829V14.1429Z",
    fill: "#444444"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5.33105,
    width: 0.857143,
    height: 6.85714,
    fill: "#444444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.14258,
    y: 6.18896,
    width: 0.857143,
    height: 6.85714,
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.cdd83a9c9b797ee05ca5d8575d30a5ba.svg";
export { ForwardRef as ReactComponent };